// extracted by mini-css-extract-plugin
module.exports = {"down":"BestPeriod_down__2xQvg","percent":"BestPeriod_percent__w22y0"};